/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './combousers.reducer';

export const CombousersDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const combousersEntity = useAppSelector(state => state.combousers.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="combousersDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.combousers.detail.title">Combousers</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.combousers.id">Id</Translate>
            </span>
          </dt>
          <dd>{combousersEntity.id}</dd>
          <dt>
            <span id="comboUserId">
              <Translate contentKey="tinyMedicRestApp.combousers.comboUserId">Combo User Id</Translate>
            </span>
          </dt>
          <dd>{combousersEntity.comboUserId}</dd>
          <dt>
            <span id="glucoUserId">
              <Translate contentKey="tinyMedicRestApp.combousers.glucoUserId">Gluco User Id</Translate>
            </span>
          </dt>
          <dd>{combousersEntity.glucoUserId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.combousers.active">Active</Translate>
            </span>
          </dt>
          <dd>{combousersEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.combousers.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{combousersEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.combousers.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{combousersEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.combousers.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{combousersEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.combousers.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{combousersEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/combousers" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/combousers/${combousersEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CombousersDetail;
